import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { faBuildingCircleCheck } from '@fortawesome/pro-regular-svg-icons';

import { dateValueToText, stringValueToText } from '../utils';
import SectionCard from './SectionCard';

interface CspDetailsSectionProps {
  street?: string;
  ein?: string;
  city?: string;
  website?: string;
  state?: string;
  stockSymbol?: string;
  postalCode?: string;
  stockExchange?: string;
  country?: string;
  createDate?: number | string;
}

const Content = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  row-gap: 12px;
  font-family: Roboto, sans-serif;
`;

const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 164px 1fr;
`;

const Field = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #4d5659;
`;

const Value = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #4d5659;
`;

const CspDetailsSection: FunctionComponent<CspDetailsSectionProps> = ({
  street,
  ein,
  city,
  website,
  state,
  stockSymbol,
  postalCode,
  stockExchange,
  country,
  createDate,
}) => {
  return (
    <SectionCard
      icon={faBuildingCircleCheck}
      title="CSP Details"
      dataTestId="cspDetailsSection"
    >
      <Content>
        <ItemWrapper>
          <Field>Address/Street:</Field>
          <Value data-testid="street">{stringValueToText(street)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>{country === 'US' ? 'EIN' : 'Tax Number/ID'}:</Field>
          <Value data-testid="ein">{stringValueToText(ein)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>City:</Field>
          <Value data-testid="city">{stringValueToText(city)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Website:</Field>
          <Value data-testid="website">{stringValueToText(website)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>State:</Field>
          <Value data-testid="state">{stringValueToText(state)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Stock Symbol:</Field>
          <Value data-testid="stockSymbol">
            {stringValueToText(stockSymbol)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>{country === 'US' ? 'ZIP Code' : 'Postal Code'}:</Field>
          <Value data-testid="postalCode">
            {stringValueToText(postalCode)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Stock Exchange:</Field>
          <Value data-testid="stockExchange">
            {stringValueToText(stockExchange)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Country:</Field>
          <Value data-testid="country">{stringValueToText(country)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Registered on:</Field>
          <Value data-testid="createDate">{dateValueToText(createDate)}</Value>
        </ItemWrapper>
      </Content>
    </SectionCard>
  );
};

export default CspDetailsSection;
